'use client';
var COMPONENT_ID = "Space";
var defaultProps = {
    width: 0,
    height: 0
};

export { COMPONENT_ID, defaultProps };
